import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fetchAllNews } from "../services/newsPublic";
import { sortNewsByDate } from "../utils/newsUtils";
import Header from "../components/header";
import Footer from "../components/footer";
import Pagination from "../components/blocks/pagination";
import { Select } from "../components/blocks/select";

export default function NewsList() {
  const [newsData, setNewsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [sortOrder, setSortOrder] = useState("newest");
  const newsPerPage = 18;

  useEffect(() => {
    fetchAllNews()
      .then(setNewsData)
      .catch((err) => setError(err.message || "Не удалось загрузить новости"))
      .finally(() => setLoading(false));
  }, []);

  const sortedNews = sortNewsByDate(newsData, sortOrder);

  const indexOfLastNews = currentPage * newsPerPage;
  const indexOfFirstNews = indexOfLastNews - newsPerPage;
  const currentNews = sortedNews.slice(indexOfFirstNews, indexOfLastNews);
  const totalPages = Math.ceil(sortedNews.length / newsPerPage);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleSortChange = (event) => {
    setSortOrder(event.target.value);
  };

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo({
        top: 0,
        behavior: "instant",
      });
    }, 0);
  }, [currentPage, sortOrder]);

  return (
    <div className="allNews">
      <Header />
      <div className="container">
        <div className="newsContent">
          <div className="title-section">
            <h3 className="title">Все новости</h3>
            <Select
              value={sortOrder}
              onChange={handleSortChange}
              options={[
                { value: "newest", label: "Сначала новые" },
                { value: "oldest", label: "Сначала старые" },
              ]}
            />
          </div>

          {loading && <p>Загрузка...</p>}
          {error && <p>{error}</p>}

          {!loading && !error && (
            <div className="newsBlock">
              {currentNews.map((news) => (
                <Link
                  key={news.id}
                  to={`/news/${news.id}`}
                  className="news-preview-item"
                >
                  {news.imagePreview && (
                    <img src={news.imagePreview} alt={news.title} />
                  )}
                  <div className="newsText">
                    <p>
                      {news.date} <span>{news.tegs}</span>
                    </p>
                    <h5>{news.title}</h5>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </div>
      {!loading && !error && totalPages > 1 && (
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
          maxVisiblePages={3}
        />
      )}
      <Footer />
    </div>
  );
}
